var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import memoize from 'lodash/memoize';
import { WEBGATE_DOMAIN, webgateFetch } from './webgate-fetch';
import { useS4AMastheadContext } from '../../components/S4AMastheadProvider';
import { getSilentAuthToken } from './silentAuth';
var endpoint = "".concat(WEBGATE_DOMAIN, "/s4x-me/v0/me");
var fetchCurrentUser = memoize(function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, data, formatted, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4, getSilentAuthToken(clientId)];
            case 1:
                token = (_a.sent())[0];
                if (!token)
                    return [2, null];
                return [4, webgateFetch(endpoint, token)];
            case 2:
                response = _a.sent();
                if (response.status === 401)
                    return [2, null];
                if (!response.ok)
                    throw new Error("".concat(response.status, " ").concat(response.url));
                return [4, response.json()];
            case 3:
                data = (_a.sent());
                formatted = __assign({ email: data.loginEmail }, data);
                return [2, formatted];
            case 4:
                error_1 = _a.sent();
                console.error(error_1);
                return [2, null];
            case 5: return [2];
        }
    });
}); });
export var useCurrentUser = function () {
    var clientId = useS4AMastheadContext().clientId;
    var _a = useState(undefined), user = _a[0], setUser = _a[1];
    React.useEffect(function () {
        var isMounted = true;
        if (clientId) {
            fetchCurrentUser(clientId).then(function (u) {
                if (isMounted)
                    setUser(u);
            });
        }
        return function () {
            isMounted = false;
        };
    }, [clientId]);
    return user;
};
